/**
 * ============================================================
 * QUICK VIEW — assets/quick-view.js
 * Tema: Canyon | Shopify OS 2.0
 * Versión: 2.0.0
 * ============================================================
 */

'use strict';

class QuickView {
  constructor() {
    this._init();
  }

  _init() {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.qv-trigger');
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      this._open(trigger);
    });
  }

  async _open(trigger) {
    const handle = trigger.dataset.productHandle;
    if (!handle) return;

    const productCard = trigger.closest('product-card');
    const quickAddComponent = productCard?.querySelector('quick-add-component');

    if (quickAddComponent && typeof quickAddComponent.handleClick === 'function') {
      await quickAddComponent.handleClick(new MouseEvent('click', { bubbles: true }));
      return;
    }

    await this._openManual(handle, trigger);
  }

  async _openManual(handle, trigger) {
    const dialog = document.getElementById('quick-add-dialog');
    if (!dialog) {
      window.location.href = `/products/${handle}`;
      return;
    }

    this._setLoadingState(dialog, true);

    if (typeof dialog.showDialog === 'function') {
      dialog.showDialog();
    }

    try {
      const productUrl = `/products/${handle}`;
      const response = await fetch(productUrl, {
        headers: { 'Content-Type': 'text/html' }
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const productGrid = html.querySelector('[data-product-grid-content]');

      if (productGrid) {
        const modalContent = document.getElementById('quick-add-modal-content');
        if (modalContent) {
          if (window.__themeComponents?.morph) {
            window.__themeComponents.morph(modalContent, productGrid);
          } else {
            modalContent.innerHTML = productGrid.innerHTML;
          }
        }
      }
    } catch (err) {
      console.error('[QuickView] Error al cargar producto:', err);
      if (typeof dialog.closeDialog === 'function') dialog.closeDialog();
      window.location.href = `/products/${handle}`;
    } finally {
      this._setLoadingState(dialog, false);
    }
  }

  _setLoadingState(dialog, loading) {
    const modalContent = dialog.querySelector('#quick-add-modal-content');
    if (!modalContent) return;
    modalContent.toggleAttribute('aria-busy', loading);
    if (loading) {
      modalContent.innerHTML = `
        <div style="display:flex;align-items:center;justify-content:center;min-height:300px;width:100%;">
          <div style="width:36px;height:36px;border:3px solid #e5e7eb;border-top-color:#1a1a1a;border-radius:50%;animation:qv-spin 0.7s linear infinite;"></div>
        </div>
        <style>@keyframes qv-spin { to { transform: rotate(360deg); } }</style>
      `;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.quickView = new QuickView();
});